import type { FC, ReactNode } from 'react';
import type { Options } from 'highcharts';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import { Box, Text, type TextProps } from '@eqi-investimentos/react';
import { colors } from '@eqi-investimentos/tokens';
import { useTheme } from '@chakra-ui/react';
import { semiCircleSimpleIndicatorOptions } from './options';
export const SemiCircleChart: FC<SemiCircleChartProps> = ({
  percentage,
  label,
  labelProps,
  chartCustomOptions = {
    chart: {
      width: 95,
      height: 70
    }
  }
}) => {
  const {
    isDarkMode
  } = useTheme();
  const currentTheme = isDarkMode ? 'dark' : 'light';
  const options: Options = {
    ...semiCircleSimpleIndicatorOptions,
    chart: {
      ...semiCircleSimpleIndicatorOptions.chart,
      width: chartCustomOptions?.chart?.width ?? 95,
      height: chartCustomOptions?.chart?.height ?? 70
    },
    plotOptions: {
      ...semiCircleSimpleIndicatorOptions.plotOptions,
      pie: {
        ...semiCircleSimpleIndicatorOptions.plotOptions?.pie,
        ...chartCustomOptions?.plotOptions?.pie
      }
    },
    series: [{
      type: 'pie',
      data: [{
        name: '',
        y: percentage,
        color: colors[currentTheme].content.brand
      }, {
        name: '',
        y: Number(100 - percentage),
        color: colors[currentTheme].neutral[100]
      }]
    }]
  };
  if (typeof Highcharts === 'object') {
    HighchartsAccessibility(Highcharts);
  }
  return <Box className="box_semicircle_chart" pos="relative" data-sentry-element="Box" data-sentry-component="SemiCircleChart" data-sentry-source-file="index.tsx">
      <HighchartsReact highcharts={Highcharts} options={options} data-sentry-element="HighchartsReact" data-sentry-source-file="index.tsx" />
      <Text pos="absolute" top="50%" left="50%" transform="translate(-50%, -15%)" color="content.primary" {...labelProps} data-sentry-element="Text" data-sentry-source-file="index.tsx">
        {label}
      </Text>
    </Box>;
};
type SemiCircleChartProps = {
  label: ReactNode;
  percentage: number;
  labelProps?: Omit<TextProps, 'children'>;
  chartCustomOptions?: Partial<Options>;
};